import { styled, LinearProgress as MUILinearProgress } from "@mui/material";

import { theme } from "theme";

export const LinearProgress = styled(MUILinearProgress)({
  color: theme.color.primary[600],
});
